export interface Fractal<T> extends Array<T | Fractal<T>> {}

export enum EthenaQueryParam {
  APP_URL = 'appUrl',
  CLASSROOM_KEY = 'classroomKey',
  COMPANY = 'company',
  IS_SETUP_COMPLETE = 'isSetupComplete',
  KIOSK_KEY = 'kioskKey',
  LEARNING_CENTER_LOGIN_KEY = 'key',
  NEXT_TRAINING_DATES = 'nextTrainingDates',
  REDIRECT_PATH = 'redirectPath',
  REPORTING_HUB_FOLLOW_UP_KEY = 'key',
  SCORM_EXPORT_KEY = 'key',
  SCORM_USER_LOGIN_KEY = 'scormKey',
  SCORM_USER_LOGIN_KEY_LEGACY = 'key',
  SCORM_USER_SETTINGS = 'scormUserSettings',
  SCORM_POPULATION_FILTER = 'scormPopulationFilter',
  SSO = 'sso',
  TRAINING_CENTER_FOCUSED_ASSIGNMENT_ID = 'assignmentId',
  TRAINING_CENTER_FOCUSED_SCORM_ASSIGNMENT_ID = 'scormAssignmentId',
  TRAINING_CENTER_IS_LEGACY = 'isLegacy',
}

export interface ISearchResult<T> {
  results: T[];
  limit: number;
  offset: number;
  total: number;
}
